module.exports = __webpack_public_path__ + "media/images/slider_img_sp_05-99d930b1c274c9f7120b81aa7c3c328a.png";